/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  CostCenterAutocompleteListItemDto,
  EmailTemplateAutocompleteListItemDto,
  EmailTemplateListItemDto,
  MilestoneEventDetailsDto,
  MilestoneEventFiresType,
  MilestoneEventFromToType,
  MilestoneEventType,
  MilestoneSendMethodType,
  UserSystemRole,
} from '@gh/builder-shared-data';
import { TextDictionary } from '@gh/common-shared';
import { EMPTY_ID, ID, WithVersion } from '@gh/common-shared-data';

export type MilestoneEventDetails = WithVersion<{
  milestoneEventId?: ID;
  eventDate?: EventDateAutocompleteItem;
  costCenter?: CostCenterAutocompleteListItemDto;
  sendMethod: MilestoneSendMethodType;
  template?: EmailTemplateAutocompleteListItemDto;
  sendWhen: MilestoneEventFiresType;
  numberOfDays?: number;
  sendFrom?: MilestoneEventFromToType;
  sendFromSystemRole?: UserSystemRole;
  sendTo?: MilestoneEventFromToType;
  sendToSystemRole?: UserSystemRole;
}>;

export type EmailTemplateListItem = EmailTemplateListItemDto;
export type CostCenterAutocompleteListItem = CostCenterAutocompleteListItemDto;
export type EmailTemplateAutocompleteListItem = EmailTemplateAutocompleteListItemDto;

export type EventDateAutocompleteItem = {
  id: MilestoneEventType;
  name: string;
};

export type SmsTemplateListItem = {
  id: ID;
  name: string;
};

export const MILESTONE_EVENT_DETAILS_INIT: MilestoneEventDetails = {
  milestoneEventId: EMPTY_ID,
  eventDate: void 0,
  costCenter: void 0,
  sendMethod: MilestoneSendMethodType.Email,
  template: void 0,
  sendWhen: MilestoneEventFiresType.SameDay,
  numberOfDays: void 0,
  sendFrom: void 0,
  sendFromSystemRole: void 0,
  sendTo: void 0,
  sendToSystemRole: void 0,
  version: void 0,
};

export const milestoneEventFromDto = (milestoneEventType: TextDictionary) =>
  (milestoneEvent: MilestoneEventDetailsDto) => ({
    ...milestoneEvent,
    eventDate: milestoneEvent.eventDate ? {
      id: milestoneEvent.eventDate,
      name: milestoneEventType.get(milestoneEvent.eventDate),
    } : void 0,
  });

export const milestoneEventToDto = (milestoneEvent: MilestoneEventDetails) => ({
  ...milestoneEvent,
  costCenter: milestoneEvent.costCenter
    ? { id: milestoneEvent.costCenter.id, name: milestoneEvent.costCenter.name }
    : void 0,
  eventDate: milestoneEvent.eventDate ? milestoneEvent.eventDate.id : void 0,
});
